<template>
  <div class="page-content -column -column-two">
    <h3 class="section-title -mb">Bot delays</h3>

    <label>Read delay per character <small>(default: 20)</small></label>
    <input v-model="resource.read_delay_per_char" type="number" />
    <span v-if="errors.read_delay_per_char" class="alert -inline -danger">
      {{ [...errors.read_delay_per_char].join(', ') }}
    </span>

    <label>Write delay per character <small>(default: 50)</small></label>
    <input v-model="resource.write_delay_per_char" type="number" />
    <span v-if="errors.write_delay_per_char" class="alert -inline -danger">
      {{ [...errors.write_delay_per_char].join(', ') }}
    </span>

    <action-button class="-mt" :text="'Update Settings'" :state="state" @pressed="submit"></action-button>
  </div>
</template>

<script>
import actionButton from "@/components/actionButton";
import settingsBase from "@/components/settings/base.vue";

export default {
  components: { actionButton },
  extends: settingsBase,

  data() {
    return {
      fields: ["read_delay_per_char", "write_delay_per_char"]
    };
  }
};
</script>
